import { Roles } from '@/core/types';
import RolesGuard from '@/router/guards/RolesGuard';
import SiteSupervisorDevices from '@/views/pages/devices';
import { RouteObject } from 'react-router-dom';

export default [
	{
		path: 'devices',
		element: <RolesGuard roles={[Roles.SITE_SUPERVISOR]} element={<SiteSupervisorDevices />} />,
	},
] as RouteObject[];
